import React from "react";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
function Social() {
  return (
    <>
      <div className="sm:w-full   py-10 m-auto mt-4">
        <div className="text-2xl text-bold mb-4 font-medium tracking-widest">
          FOLLOW US
        </div>
        <Link to="https://www.facebook.com/Tomedes.translation">
          <span className="inline-flex font text-center mr-4  hover:bg-orange hover:text-white cursor-pointer transition-colors duration-300">
            <FontAwesomeIcon
              icon={faFacebookF}
              className="text-2xl  inline-block m-auto "
            />
          </span>
        </Link>
        <Link to="https://twitter.com/Tomedes">
          <span className="inline-flex font text-center mr-4  hover:bg-orange hover:text-white cursor-pointer transition-colors duration-300">
            <FontAwesomeIcon
              icon={faTwitter}
              className="text-2xl  inline-block m-auto "
            />{" "}
          </span>
        </Link>
        <Link to="https://www.linkedin.com/company/tomedes.com/">
          <span className="inline-flex font text-center mr-4  hover:bg-orange hover:text-white cursor-pointer transition-colors duration-300">
            <FontAwesomeIcon
              icon={faLinkedinIn}
              className="text-2xl  inline-block m-auto "
            />{" "}
          </span>
        </Link>
        <Link to="https://www.youtube.com/channel/UC9k2By4XhHEjI6usn0nJfNw">
          <span className="inline-flex font text-center hover:bg-orange hover:text-white cursor-pointer transition-colors duration-300">
            <FontAwesomeIcon
              icon={faYoutube}
              className="text-2xl  inline-block m-auto"
            />{" "}
          </span>
        </Link>
      </div>
    </>
  );
}
export default Social;
